import classNames from 'classnames'
import { forwardRef, ThHTMLAttributes, useContext } from 'react'

import { TableContext } from './context'
import type { TableCellBaseProps } from './table-cell'
import styles from './table-row-header-cell.module.scss'

export type TableRowHeaderCellElement = HTMLTableCellElement

export type TableRowHeaderCellProps = ThHTMLAttributes<TableRowHeaderCellElement> &
  TableCellBaseProps

const TableRowHeaderCell = forwardRef<TableRowHeaderCellElement, TableRowHeaderCellProps>(
  function TableRowHeaderCell(props, ref) {
    const { className, justify, ...rest } = props
    const { getCellStyles } = useContext(TableContext)
    const classes = classNames(getCellStyles({ justify }), styles.root, className)
    return <th scope="row" {...rest} className={classes} ref={ref} />
  }
)

export default TableRowHeaderCell
